import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import { Home, ArrowRight } from "lucide-react";

// Friendly 404 — no dead-end blank page, keeps trust intact even when
// someone hits a mistyped URL.
export default function NotFound() {
  return (
    <div className="bg-white">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="text-xs font-semibold tracking-widest text-blue-700 uppercase">
          404
        </div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-heading font-semibold text-slate-900">
          We couldn't find that page.
        </h1>
        <p className="mt-4 text-slate-600 max-w-xl mx-auto">
          The link may have moved or the URL may be mistyped. From here you can
          head back to the homepage or reach out to us on WhatsApp — we usually
          reply within a few hours.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-blue-700 text-white font-semibold hover:bg-blue-800 transition-colors"
          >
            <Home size={16} /> Back to homepage
          </Link>
          <Link
            to="/contact"
            data-testid="notfound-contact"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-slate-300 text-slate-800 font-semibold hover:border-slate-400 hover:bg-slate-50 transition-colors"
          >
            Contact us <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
